import xhrCaller from "./xhr-caller";


export const xhrPatientGetPatientAll = async (token, page, perPage) => {
    
    var result = await xhrCaller({ bearer: token, srv: 'api', action: `Patient/GetPatientAll?pi=${page??0}&pr=${perPage??200}`});
	return result;
}

export const xhrPatientGetPatientById = async (token, id) => {

    var result = await xhrCaller({ bearer: token, srv: 'api', action: `Patient/GetPatientById?id=${id}`});
	return result;
}

export const xhrPatientGetPatientByIdentification= async (token, tid, id) => {

    var result = await xhrCaller({ bearer: token, srv: 'api', action: `Patient/GetPatientByIdentification?ident=${id}&tid=${tid}`});
	return result;
}

export const xhrPatientDeletePatient = async (token, data) => {

    var result = await xhrCaller({ bearer: token, srv: 'api', data: data.id, method: "delete", action: `Patient/DeletePatient?id=${data.id}`});
	return result;

}

export const xhrPatientGetPatientBySearch = async (token, data) => {

	var result = await xhrCaller({ bearer: token, srv: 'api', data, action: `Patient/GetPatientBySearch`});
	return result;
}

export const xhrPatientGetStudiesForPatient = async (token, PatientIdentifier, tenantId) => {

	var result = await xhrCaller({ bearer: token, srv: 'wado', action: `Patient/GetStudiesForPatient?PatientId=${PatientIdentifier}&TenantId=${tenantId}`});
	return result;
}
